import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.dashboard');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";
import { INITIAL_COLLECTIONS, INITIAL_STATS } from './static-cache';

@Component({
    selector: 'wiz-page-dashboard',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.dashboard/view.scss */
:host {
  display: block;
  height: 100%;
}`],
})
export class PageDashboardComponent implements OnInit {
    public stats: any = INITIAL_STATS;
    public collections: any[] = INITIAL_COLLECTIONS;
    public loading: boolean = false;
    public loadingProgress: number = 100;
    public loadingStage: string = '캐시 표시 완료';

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        await this.service.auth.allow("/access");
        await this.service.render();
        this.loadStaticOverviewCache()
            .then(async () => await this.service.render())
            .catch(() => false)
            .then(() => this.refreshOverviewFromApi(true))
            .catch((e: any) => console.error(e));
    }

    public async load() {
        this.loading = true;
        this.setLoadingProgress(5, '정적 캐시 요청 중');
        await this.service.render();

        const cacheLoaded = await this.loadStaticOverviewCache();
        if (cacheLoaded) await this.renderLoadingProgress(72, '정적 캐시 적용 완료');
        await this.renderLoadingProgress(82, '대시보드 API 동기화 중');
        await this.refreshOverviewFromApi(false);
        await this.renderLoadingProgress(100, '표시 준비 완료');
        this.loading = false;
        await this.service.render();
    }

    private applyOverviewPayload(data: any) {
        this.stats = data?.stats || {};
        this.collections = data?.collections || [];
    }

    private async loadStaticOverviewCache(): Promise<boolean> {
        try {
            const response = await fetch('/assets/cache/dashboard_overview.json', { cache: 'force-cache' });
            if (!response.ok) return false;
            this.applyOverviewPayload(await response.json());
            return true;
        } catch (e) {
            return false;
        }
    }

    private async refreshOverviewFromApi(background: boolean) {
        try {
            const { code, data } = await wiz.call("overview");
            if (code === 200) {
                this.applyOverviewPayload(data);
                if (background) await this.service.render();
            }
        } catch (e) {
            console.error(e);
        }
    }

    private setLoadingProgress(progress: number, stage: string) {
        this.loadingProgress = progress;
        this.loadingStage = stage;
    }

    private async renderLoadingProgress(progress: number, stage: string) {
        this.setLoadingProgress(progress, stage);
        await this.service.render();
    }

    public get completionPercent(): number {
        const total = this.stats.documents || 0;
        if (total === 0) return 0;
        return Math.round(((this.stats.completed || 0) / total) * 100);
    }

    public get activeDocuments(): number {
        return (this.stats.pending || 0) + (this.stats.processing || 0);
    }

    public get issueDocuments(): number {
        return this.stats.failed || 0;
    }

    public get hasData(): boolean {
        return (this.stats.collections || 0) > 0 || (this.stats.documents || 0) > 0;
    }

    public get visibleCollections(): any[] {
        return (this.collections || []).slice(0, 8);
    }

    public colCompletionPct(col: any): number {
        const total = col.total_docs || 0;
        if (total === 0) return 0;
        return Math.round(((col.completed_docs || 0) / total) * 100);
    }

    public collectionStatusLabel(col: any): string {
        const total = col.total_docs || 0;
        const pct = this.colCompletionPct(col);
        if (total === 0) return '자료 없음';
        if (pct === 100) return '완료';
        if (pct > 0) return '진행 중';
        return '대기';
    }

    public collectionStatusClass(col: any): string {
        const total = col.total_docs || 0;
        const pct = this.colCompletionPct(col);
        if (total === 0) return 'bg-stone-100 text-stone-500 dark:bg-stone-800 dark:text-stone-400';
        if (pct === 100) return 'bg-emerald-50 text-emerald-700 dark:bg-emerald-400/10 dark:text-emerald-300';
        if (pct > 0) return 'bg-amber-50 text-amber-700 dark:bg-amber-400/10 dark:text-amber-300';
        return 'bg-sky-50 text-sky-700 dark:bg-sky-400/10 dark:text-sky-300';
    }

    public collectionProgressBarClass(col: any): string {
        const pct = this.colCompletionPct(col);
        if (pct === 100) return 'bg-emerald-500';
        if (pct > 0) return 'bg-amber-500';
        return 'bg-stone-300 dark:bg-stone-600';
    }
}

export default PageDashboardComponent;